import dayjs from 'dayjs';
import strings from '../../Globalization';
import util from '../../util';

export const evalReceiptHTML = (cycleTape) =>
	cycleTape
		?.replace?.('<PrinterLines />', '')
		?.replace?.(/<PrinterLine>/g, '')
		?.replace?.(/<PrinterLine \/\>/g, '<br/>')
		?.replace?.(/<\/\PrinterLine>/g, '<br/>')
		?.replace?.(/PrinterLines/g, 'p')
		?.replace?.(/ /g, '&nbsp;');

export const getPrintDetailsParams = ({ data }) => {
	const evaledHeaderSection = data.TopSection;
	let topSection = [];
	const dateTimeFormat = util.getDateTimeFormat();
	const printData = data.CycleTape || data.PrinterLines || '';
	const dataProperty = [
		{ Property: 'ReportTitle', Value: strings.CycleLogs || '', LangString: strings.CycleLogs },
		{ Property: 'EquipmentName', Value: data.EquipmentName || '', LangString: strings.EquipmentName },
		{ Property: 'EquipmentType', Value: data.EquipmentTypeName || '', LangString: strings.EquipmentType },
		{ Property: 'SerialNumber', Value: data.SerialNumber || '', LangString: strings.SerialNumber },
		{ Property: 'ModelName', Value: data.ModelName || '', LangString: strings.ModalName },
		{ Property: 'Location', Value: data.LocationName || '', LangString: strings.LocationName },
		{ Property: 'CycleCount', Value: data.CycleCount || '', LangString: strings.CycleCount },
		{
			Property: 'CycleDate',
			Value: dayjs(data.CycleStart).format(dateTimeFormat.datetime) || '',
			LangString: strings.CycleDateTime
		},
		{ Property: 'Parameter', LangString: strings.Parameter },
		{ Property: 'Metric', LangString: strings.Metric },
		{ Property: 'Actual', LangString: strings.Actual },
		{ Property: 'Control', LangString: 'Control' },
		{ Property: 'Independent', LangString: 'Independent' },
		{ Property: 'CriticalParamenterTitle', LangString: strings.CriticalParamenterTitle }
	];

	if (Array.isArray(evaledHeaderSection)) {
		topSection = evaledHeaderSection.map((item) => ({
			...item,
			Label: strings[item.HeaderLabel] || item.HeaderLabel,
			Value: item.hasOwnProperty('image') ? '' : item.Value,
			Image: item.image || '',
			Index: item.Index >= 0 ? item.Index : -1
		}));
	}

	const criticalParameters = data.VisibleCriticalParameters.map((obj) => ({
		HeaderLabel: strings.formatString(strings[obj.HeaderLabel.trim()], obj?.LabelFormatterValue || ''),
		SubHeaderLabel: obj.SubHeaderLabel || '',
		Index: obj.Index || 0,
		UnitHeader: obj.UnitHeader || '',
		UnitSubHeader: obj.UnitSubHeader || '',
		ColSpan: obj.ColSpan || 0,
		RowSpan: obj.RowSpan || 0,
		Metric: obj.Metric || '',
		Actual: obj.Actual || '',
		CriticalParameterIcon: obj.CriticalParameterIcon,
		Control: obj.Control || '',
		Independent: obj.Independent || '',
		TabHeader: obj.TabHeader || false
	}));
	const requestParameters = [
		{ Name: 'action', Value: 'otherAction' },
		{ Name: 'otherAction', Value: 'printReport' },
		{ Name: 'cycleCount', Value: data.CycleCount },
		{ Name: 'imageUrl', Value: data.SterilizerImageUrl },
		{ Name: 'cycleName', Value: data.CycleName },
		{ Name: 'cycleTape', Value: printData },
		{ Name: 'topSection', Value: JSON.stringify(topSection) },
		{ Name: 'criticalParameters', Value: JSON.stringify(criticalParameters) },
		{ Name: 'pageInfo', Value: JSON.stringify(dataProperty) },
		{ Name: 'isSterilizer', Value: true }
	];


	return requestParameters;
};